import React from 'react'
import View from '../assets/images/svg/view_blue.svg'
import Download from '../assets/images/svg/download.svg'
import { Link } from 'react-router-dom'
const DownloadFile = ({ title, urlView, urlDownload,bold }) => {
    return (
        <div className={`downloadFile ${bold ? "bold": ""}`}>
            <p>{title}</p>
            <div className='choose'>
                <Link _blank to={urlView}><img src={View} alt="View" /></Link>
                <Link to={urlDownload}><img src={Download} alt="" /></Link>
            </div>
        </div>
    )
}

export default DownloadFile